/**
 * @file
 * Karhu Helsinki theme javascripts
 */

(function ($, Drupal) {

  "use strict";

  Drupal.behaviors.pdfpreloader = {
    attach: function(context, settings) {
      var myAjaxObject = $.ajax({
        url: settings.pdfPreloader,
      },{
        timeout: 500,
      }).done(function(response) {
        window.location.href = settings.pdfPreloader;
      }).fail(function() {
        alert( "error" );
      });
    }
  };

})(jQuery, Drupal);
